module.exports = __webpack_public_path__ + "img/V-R-5-unload-standup-shadow.571b18d9.png";